module.exports = __webpack_public_path__ + "img/valuationFormula.3aa0de0d.png";